import { Route } from '@angular/router';

export const PrescriptionsMainRoute: Route = {
  path: 'prescriptions',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/prescriptions_shell'
    ).then((c) => c.PrescriptionsShellMainRoutes);
  },
};
